<template>
  <div class="home">
    <parallax sectionClass="Masthead main" :sectionHeight="100">
      <navigation />
      <b-container class="header-position">
        <b-row>
          <b-col style="position: relative">
            <h1 class="image-header">Ferienhausvermietung Wolfgang Weber</h1>
          </b-col>
        </b-row>
      </b-container>
      <b-container style="position: absolute; top: 30vh; left: 0; right: 0;">
        <b-row>
          <b-col>
            <p class="image-paragraph">
              Unser Ferienhaus liegt zentral zwischen dem Nationalpark Sächsische Schweiz und der Landeshauptstadt Dresden. Sie können Ihren Urlaub abwechslungsreich gestalten. Sie können Wandern, Klettern, Radfahren oder Museen, Burgen und Städte besichtigen.
            </p>
          </b-col>
        </b-row>
      </b-container>
      <img src="https://ferienhaus.webdev-jogeleit.de/images/weber_front.jpg" />
    </parallax>
    <div>
      <b-container>
        <b-row>
          <b-col>
            <h2>Kontakt</h2>
            <div class="line-wrapper"><span class="line"></span></div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <gmap-map style="height: 300px;"
                      :center="{ lat:50.925610, lng:13.963740 }"
                      :zoom="15"
                      map-type-id="roadmap"
            >
              <gmap-marker :position="{ lat:50.925610, lng:13.963740 }"
                           :clickable="true"
              ></gmap-marker>
            </gmap-map>
          </b-col>
          <b-col>
            <p>
              Wolfgang Weber<br>
              Eichgrundweg 9<br>
              01796 Pirna<br>
              <br>
              Telefon: <a href="tel:+493501762432">03501 762432</a><br>
              Mobile: <a href="tel:+4915157164841">0151 57164841</a><br>
              E-Mail: <a href="mailto:info@ferienhausvermietung-weber.de">info[at]ferienhausvermietung-weber.de</a>
            </p>
            <p>
              Freie Termine und weitere Informationen inkl. Online Buchung auf
              <a href="https://www.fewo-direkt.de/ferienwohnung-ferienhaus/p500513?uni_id=140082">FeWo&nbsp;Direkt</a> oder <a href="https://www.traum-ferienwohnungen.de/16355/">Traum-Ferienwohnungen</a>.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Parallax from 'vue-parallaxy'
import OutdoorGallery from '../components/OutdoorGallery'
import IndoorGallery from '@/components/IndoorGallery'
import AppDetails from '@/components/Details'
import Navigation from '@/components/Navigation'

export default {
  name: 'home',
  metaInfo: {
    title: 'Ferienhaus Weber',
    htmlAttrs: {
      lang: 'de'
    },
    meta: [
      { name: 'description', content: 'Unser Ferienhaus liegt zentral zwischen dem Nationalpark Sächsische Schweiz und der Landeshauptstadt Dresden. Sie können Ihren Urlaub abwechslungsreich gestalten. Sie können Wandern, Klettern, Radfahren, oder Museen, Burgen und Städte besichtigen.' },
      { name: 'keywords', content: 'Sächsische Schweiz, Pirna, Dresden, Wanderung, Ländlich, Bergsteigen, Paddeln, Active Urlaub' }
    ]
  },
  components: {
    Navigation,
    IndoorGallery,
    Parallax,
    OutdoorGallery,
    AppDetails
  }
}
</script>

<style>
  body .Masthead.main,
  body .Masthead.second {
    z-index: 99;
  }

  @media screen and (min-width: 768px) {
    body .Masthead.main {
      min-height: 590px;
    }

    body .Masthead.second {
      min-height: 200px;
      max-height: 200px;
    }
  }

  .image-header {
    font-family: 'Alegreya SC', serif;
    font-weight: bold;
    font-size: 3.2rem;
    color: #fff;
    text-shadow: -1px 0 #333, 0 1px #333, 1px 0 #333, 0 -1px #333;
  }

  .header-position {
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
  }

  @media screen and (max-width: 767px) {
    body .image-header {
      font-size: 1.7rem;
    }

    body .header-position {
      top: 100px
    }

    body .image-paragraph {
      font-size: 1.2rem;
    }
  }

  .image-paragraph {
    border: 2px solid #fff;
    padding: 1rem 1rem;

    font-family: 'Alegreya SC', serif;
    font-size: 1.75rem;
    color: #fff;
    line-height: 2rem;
    background-color: RGBA(55, 55, 55, 0.75);
  }

  .main-nav .nav-item {
    position: relative;
  }

  .main-nav .nav-item:not(:first-child):after {
    position: absolute;
    right: -0.15rem;
    top: 0.55rem;
    content: '/';
    color: #fff;
  }
</style>
